import NamesJSON from '../../../names.json'

/**
 * Walidacja sprawdzająca czy podane imię znajduje się w słowniku imion
 */
export const isNameValid = {
   name: 'isNameValid',
   message: 'Imię niepoprawne. Sprawdź pisownię',
   test: (nameToCheck: string | undefined) => {
      const namesArray = NamesJSON.Names

      if(nameToCheck?.length){
          return namesArray.some((name) => (name.FirstName).toLocaleLowerCase() === nameToCheck.trim().toLocaleLowerCase())
      }
      else {
         return false
      }
   }
}